const ovhDiscordUrl = 'https://discord.gg/ovhcloud'

export {
  ovhDiscordUrl
}
